import React from 'react';
import './AboutUs.css'; 
import Footer from './footer';
const AboutUs = () => {
  return (
    <><section className="about-page about-section py-16 bg-light-yellow">
      <div className="container mx-auto px-4">
 
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bold text-dark-blue mb-4">Guardians Home Care</h1>
          <h2 className="text-3xl font-light text-gray-700 mb-8">Bringing Healthcare to Your Doorstep</h2>
        </div>

 
        <div className="text-center mb-12">
          <p className="text-lg leading-relaxed text-gray-700 max-w-3xl mx-auto">
            At Guardians Home Care, we understand that healthcare needs are diverse and personal. That’s why we bring medical services to your home, ensuring comfort and convenience for you and your loved ones. Our services are tailored to meet the unique needs of each patient, providing comprehensive care that covers both medical consultations and essential medical equipment rentals.
          </p>
        </div>

 
        <div className="founder-section mb-12 flex flex-col items-center text-center">
          <div className="w-2/3 mb-4">
            <img src="/drkamalgupta.jpg" alt="Dr. Kamal Gupta" className="w-full rounded-lg shadow-md" />
          </div>
          <div className="w-full">
            <h3 className="text-3xl font-semibold text-dark-blue mb-4">Meet Dr. Kamal Gupta</h3>
            <p className="text-lg leading-relaxed text-gray-700">
              Dr. Kamal Gupta, MBBS, is the visionary behind Guardians Home Care. With many years of experience in the medical field, Dr. Gupta has dedicated his career to improving patient care. Known for his expertise and compassionate approach, Dr. Gupta is committed to making healthcare more accessible and personalized.
            </p>
          </div>
        </div>


 
        <div className="mission-vision-section text-center">
          <h2 className="text-4xl font-bold text-dark-blue mb-8 ds">Our Mission & Vision</h2>

          <div className="flex justify-between items-start w-full md:w-2/3 mx-auto">
 
            <div className="w-1/2 pr-4 border-r-2 border-gray-300">
              <h4 className="text-2xl font-semibold text-dark-blue mb-3">Our Mission</h4>
              <p className="text-lg leading-relaxed text-gray-700">
                To provide high-quality, accessible healthcare services at home, ensuring that every patient receives the care they deserve in a comfortable environment.
              </p>
            </div>

 
            <div className="w-1/2 pl-4">
              <h4 className="text-2xl font-semibold text-dark-blue mb-3">Our Vision</h4>
              <p className="text-lg leading-relaxed text-gray-700">
                To be the leading provider of home healthcare services, recognized for our dedication to patient-centered care and innovation in medical service delivery.
              </p>
            </div>
          </div>
        </div>
      </div>

    </section><Footer /></>

  );
};

export default AboutUs;
